export default "__VITE_ASSET__BRlEBkQ$__"